import { faCircleExclamation, faList } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Popover, Spinner } from "react-bootstrap";
import get_gateway_config_icon from "src/assets/images/get_gateway_config_icon.png";
import { ConfigurationStatusIndicator } from "../general-configuration/components/configuration-status.component";
import type { AsyncStatus } from "./types";

type GetConfigButtonProps = {
  status: AsyncStatus;
  isLoading: boolean;
  onGetConfig: () => void;
  onViewResult: () => void;
  label: string;
  countdown?: number;
  isUpdatedByZone?: boolean;
  updateStatusMessage?: string;
};

export function GetConfigButton({
  status,
  isLoading,
  onGetConfig,
  onViewResult,
  label,
  countdown,
  isUpdatedByZone,
  updateStatusMessage,
}: GetConfigButtonProps) {
  return (
    <>
      <button
        type="button"
        className="configuration-button configuration-button--compact"
        onClick={onGetConfig}
        disabled={status === "pending"}
      >
        <img src={get_gateway_config_icon} alt={`${label} icon`} />
        <span style={{ marginTop: "4px" }}>{label}</span>
      </button>

      <ConfigurationStatusIndicator status={status} countdown={countdown} />

      <button
        type="button"
        className="gateway-config-view-btn"
        onClick={onViewResult}
        title="View command results"
      >
        {isLoading ? (
          <Spinner
            animation="border"
            variant="primary"
            size="sm"
            className="ms-2"
          />
        ) : (
          <FontAwesomeIcon icon={faList} />
        )}
      </button>

      {isUpdatedByZone && (
        <OverlayTrigger trigger="click" delay={{ show: 1, hide: 1 }} overlay={<Popover id="popover-basic">
          <Popover.Body>
            {updateStatusMessage}
          </Popover.Body>
        </Popover>}>
          <button
            type="button"
            className="gateway-config-view-btn"
            title={updateStatusMessage || ""}
          >
            <FontAwesomeIcon size="lg" icon={faCircleExclamation} style={{ color: "orange" }} />
          </button>
        </OverlayTrigger>
      )}
    </>
  );
}